import styled from "styled-components";

export const Wrapper = styled.div``;

export const InputSelect = styled.select`
  width: 100%;
  height: ${(p) => `${p.height}px`};
  min-height: ${(p) => `${p.minHeight}px`};
  cursor: pointer;
  padding: 0 15px;
  font-size: 16px;
  color: #444;
  border: ${(p) =>
    p.error
      ? `1px solid ${p.theme.color[p.error]}`
      : p.focused
      ? `1px solid ${p.theme.color.primary}`
      : "1px solid #ccc"};
  border-radius: 4px;
  background-color: ${(p) => (p.disabled ? "#eee" : "white")};

  &:focus {
    outline: none;
  }

  &:hover {
    border-color: ${(p) => !p.disabled && !p.error && p.theme.color.primary};
  }
`;

export const Option = styled.option``;

export const Label = styled.label`
  font-weight: bold;
  font-size: 1rem;
  color: ${(p) => (p.error ? p.theme.colors[p.error] : p.theme.colors.primary)};
`;

export const SubTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  min-height: 24px;
`;

export const ErrorText = styled.p`
  margin-bottom: 0;
  font-size: 12px;
  color: ${(p) => p.theme.colors.danger};
`;

export const SubLabel = styled.p`
  margin-bottom: 0;
  justify-self: flex-end;
  font-size: 12px;
  text-align: right;
  color: rgba(0, 0, 0, 0.5);
`;
